export default __webpack_public_path__ + "static/media/banner-bg.f242470e.svg";